import React from "react";
import { Drawer, Button } from "antd";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

export default class JobDetails extends React.Component {
  state = { visible: false, selectedJob: null };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onChange = (e) => {
    this.setState({
      placement: e.target.value,
    });
  };

  render() {
    const { selectedJob } = this.state;
    const { job } = this.props;
    return (
      <>
        <Button
          className="applyButtonProgram "
          onClick={() => {
            this.setState({ selectedJob: job, visible: true });
          }}
        >
          View Job
        </Button>
        <Drawer
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
          width={window.innerWidth > 500 ? 1100 : window.innerWidth - 20}
          className="applicantDrawer"
          placement="right"
          title={
            // "Create a new account"
            <div
              style={{
                textAlign: "center",
              }}
            >
              <h3>Applicant Drawer</h3>
              <h5 className="tc">
                {this.props.selectedJob
                  ? "Applying for WORK - " + selectedJob.jobTitle
                  : "APPLY@W4WORK"}
              </h5>
            </div>
          }
          footer={
            <div
              style={{
                textAlign: "center",
              }}
            >
              <Button className="applyButtonProgram" onClick={this.onClose}>
                {"Close"}
              </Button>
            </div>
          }
        >
          {selectedJob ? (
            <div>
              <Row xs="2" sm="2" md="4">
                <Col>
                  {" "}
                  <strong>Department</strong>
                  <p className="lead">{selectedJob.department}</p>
                </Col>
                <Col>
                  {" "}
                  <strong> Program</strong>
                  <p className="lead">{selectedJob.program}</p>
                </Col>
                <Col>
                  {" "}
                  <strong> Designation</strong>
                  <p className="lead">{selectedJob.designation}</p>
                </Col>
                <Col>
                  <strong> Location</strong>
                  <p className="lead">{selectedJob.location}</p>
                </Col>
              </Row>
              <br />
              <Row xs="3" sm="3" md="4">
                <Col>
                  <strong> Schedule</strong>
                  <p className="lead">{selectedJob.schedule}</p>
                </Col>
                <Col>
                  <strong> Salary Type</strong>
                  <p className="lead">{selectedJob.salaryType}</p>
                </Col>
                <Col>
                  <strong> Gender</strong>
                  <p className="lead">{selectedJob.gender}</p>
                </Col>
              </Row>
              <br />
              <hr className="my-2" />

              <h2 className="tc">
                <strong> Requirements:</strong>
              </h2>
              <p className="lead">
                <br />
                {selectedJob.requirements}
              </p>
              <br />
              <hr className="my-2" />

              <h2 className="tc">
                <strong> Job Description:</strong>
              </h2>
              <br />
              <div
                className="lead"
                dangerouslySetInnerHTML={{
                  __html: selectedJob.jd,
                }}
              />
              <br />
            </div>
          ) : null}
        </Drawer>
      </>
    );
  }
}
